import {
  Box,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead
} from '@mui/material';
import { StyledTableCell, StyledTableRow } from '@components/StyledTable';
import {
  FetchVentureBizQuery,
  Maybe,
  useFetchVentureBizQuery,
  VentureBizSearchType
} from '@generated/graphql';
import useQueryString from '@hooks/useQueryString';
import { ArrElement } from '@utils/types';
import { useState } from 'react';
import { DetailDrawer } from '@components/DetailDrawer';

export type VentureBizData = ArrElement<
  NonNullable<FetchVentureBizQuery['fetchVentureBiz']['data']>['icxModelList']
>;

type VentureBizParamsType = {
  page: string;
  q: string;
  searchType: Maybe<VentureBizSearchType>;
};

const LIMIT = 14;

const Venture = () => {
  const { onUpdateQueryString, query } = useQueryString<VentureBizParamsType>();
  const [drawer, setDrawer] = useState<{
    open: boolean;
    data?: VentureBizData;
  }>({
    open: false
  });
  const page = Number(query.page ?? 1);

  const { data, loading, error } = useFetchVentureBizQuery({
    variables: {
      input: {
        keyword: query.q,
        limit: LIMIT,
        offset: (page - 1) * LIMIT,
        ventureBizSearchType: query.searchType
      }
    }
  });

  if (loading || error) {
    return null;
  }

  const handleOpenDetailPage = (
    id: string | null | undefined,
    data: VentureBizData
  ) => {
    if (!id) {
      return;
    }

    setDrawer({ open: true, data });
  };

  const ventureBizList = data?.fetchVentureBiz.data?.icxModelList ?? [];
  const ventureBizTotalCount = data?.fetchVentureBiz.data?.count ?? 0;
  return (
    <>
      <TableContainer component={Paper} sx={{ minWidth: 800 }}>
        <Table>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell>기업명</StyledTableCell>
              <StyledTableCell>전화번호</StyledTableCell>
              <StyledTableCell>관련업종</StyledTableCell>
              <StyledTableCell>업종 1</StyledTableCell>
              <StyledTableCell>지역</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {ventureBizList.map((ventureBizData) => (
              <StyledTableRow
                onClick={() =>
                  handleOpenDetailPage(ventureBizData.id, ventureBizData)
                }
                key={ventureBizData.id}
                sx={{
                  '&:hover': {
                    cursor: 'pointer',
                    backgroundColor: '#00000030'
                  }
                }}
              >
                <StyledTableCell>{ventureBizData.companyName}</StyledTableCell>
                <StyledTableCell>{ventureBizData.contact}</StyledTableCell>
                <StyledTableCell>
                  {ventureBizData.relatedIndustry}
                </StyledTableCell>
                <StyledTableCell>{ventureBizData.industryName}</StyledTableCell>
                <StyledTableCell>{ventureBizData.region}</StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        padding={2}
        width={'100%'}
        display={'flex'}
        justifyContent={'center'}
      >
        <Pagination
          count={Math.ceil(ventureBizTotalCount / LIMIT)}
          page={page}
          color={'primary'}
          onChange={(e, value) => {
            onUpdateQueryString({ page: `${value}` });
          }}
        />
        <DetailDrawer
          open={drawer.open}
          onClose={() => setDrawer({ open: false })}
          detailInfo={drawer.data}
          tables={[
            {
              title: '기본 정보',
              table: DefaultTable
            }
          ]}
        />
      </Box>
    </>
  );
};

export default Venture;

const DefaultTable = {
  companyName: '사업자명',
  contact: '전화번호',
  relatedIndustry: '관련업종',
  industryName: '업종 1',
  region: '지역'
};
